import TrainingRegistrationHeader from './TrainingRegistrationHeader.vue';

export default TrainingRegistrationHeader;
